module.exports = __webpack_public_path__ + "media/images/core_values/service_to_others-d7da84099f1d29ae05b896cd29a38f94.png";